import { createFrontendPlugin, type FrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityIconLinkBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Entity } from '@backstage/catalog-model';
import { useOwnershipStatusIconLinkProps } from './components/OwnershipStatusIconLink';
import { OWNERSHIP_STATUS_ANNOTATION } from './utils/ownershipStatus';
import { rootRouteRef } from './routes';

const ownershipStatusIconLink = EntityIconLinkBlueprint.make({
  name: 'ownership-status',
  params: {
    filter: (entity: Entity) =>
      Boolean(entity.metadata.annotations?.[OWNERSHIP_STATUS_ANNOTATION]),
    useProps: useOwnershipStatusIconLinkProps,
  },
});

export const manageOwnershipPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'manage-ownership',
  extensions: [ownershipStatusIconLink],
  routes: {
    root: rootRouteRef,
  },
});
